import { render, staticRenderFns } from "./HotelsToggledNotification.vue?vue&type=template&id=45758299"
import script from "./HotelsToggledNotification.vue?vue&type=script&lang=js"
export * from "./HotelsToggledNotification.vue?vue&type=script&lang=js"
import style0 from "./HotelsToggledNotification.vue?vue&type=style&index=0&id=45758299&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports